import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initTheme } from "./components/common/ColorSwitcher/ColorSwitcher";
import { ROUTER_FUTURE_FLAGS } from "./common/routerFuture";

import "./index.css";

/* self-hosted Inter: Latin subset, weight-subset to design system usage */
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import "@fontsource/inter/latin-800.css";

import "./common/styles/fontawesome-icons.css";
import "./common/styles/bootstrap-lite.css";

/* custom theme overrides - always after bootstrap */
import "./common/styles/theme.css";

/* Bootstrap's JS bundle is deliberately NOT imported: the application uses
   no Bootstrap JS components (the template's offcanvas drawer and dropdown
   were removed in Phase 02/04). Re-add it only if one is reintroduced. */

/* apply the stored (or default light) theme before first paint */
initTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter future={ROUTER_FUTURE_FLAGS}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
